import { useState, useEffect } from 'react';
import '../styles/FilterGallery.css'; // Make sure you have this CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { getApiBase, withBase } from '../config/api'; // Make sure this path is correct
import fallbackImage from '../assets/fallback.jpg'; // Make sure this path is correct
import galleryOne from '../assets/album/one.jpg';
import galleryTwo from '../assets/album/two.jpg';
import galleryThree from '../assets/album/omaxe.jpg';
import galleryFour from '../assets/album/omaxeee.jpg';
import galleryFive from '../assets/album/album_one.jpg';
import gallerySix from '../assets/album/album_two.jpg';

const galleryFallback = {
  categories: [{ id: 1, key: 'highlights', name: 'Highlights' }],
  images: [
    { id: 1, category_id: 1, src: galleryOne, label: 'Gallery 1' },
    { id: 2, category_id: 1, src: galleryTwo, label: 'Gallery 2' },
    { id: 3, category_id: 1, src: galleryThree, label: 'Gallery 3' },
    { id: 4, category_id: 1, src: galleryFour, label: 'Gallery 4' },
    { id: 5, category_id: 1, src: galleryFive, label: 'Gallery 5' },
    { id: 6, category_id: 1, src: gallerySix, label: 'Gallery 6' },
  ],
};

const resolveImageSrc = (src) => {
  if (!src) return fallbackImage;
  if (/^https?:\/\//i.test(src)) return src;
  if (src.startsWith('/uploads') || src.startsWith('/api/uploads')) {
    return withBase(src);
  }
  return src;
};

const FilterGallery = () => {
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [filterKey, setFilterKey] = useState('all'); // Use the category key for filtering
  const [lightboxImg, setLightboxImg] = useState(null);

  useEffect(() => {
    const fetchGalleryData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${getApiBase()}/api/gallery-all`);
        const categories = res.data.categories || [];
        const images = res.data.images || [];

        if (categories.length === 0 || images.length === 0) {
          setCategories(galleryFallback.categories);
          setImages(galleryFallback.images);
        } else {
          setCategories(categories);
          setImages(images);
        }
      } catch (err) {
        console.error("Failed to load gallery data", err);
        setCategories(galleryFallback.categories);
        setImages(galleryFallback.images);
      } finally {
        setLoading(false);
      }
    };
    fetchGalleryData();
  }, []);

  const filteredImages = filterKey === 'all'
    ? images
    : images.filter(img => img.category_id === categories.find(c => c.key === filterKey)?.id);

  const handleImgError = (e) => {
    e.target.src = fallbackImage;
  };

  return (
    <section className="py-5">
      <div className="container">
        {/* Filter Buttons */}
        <ul className="d-flex flex-wrap justify-content-center gap-2 mb-4">
          <li
            key="all"
            className={`brand-tab ${filterKey === 'all' ? 'brand-tab-active' : ''}`}
            onClick={() => setFilterKey('all')}
          >
            All
          </li>
          {categories.map(cat => (
            <li
              key={cat.key}
              className={`brand-tab ${filterKey === cat.key ? 'brand-tab-active' : ''}`}
              onClick={() => setFilterKey(cat.key)}
            >
              {cat.name}
            </li>
          ))}
        </ul>

        {/* Gallery Grid */}
        {loading ? (
          <div className="text-center p-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading Gallery...</span>
            </div>
          </div>
        ) : (
          <div className="row g-3 brand-gallery">
            {filteredImages.map((img) => (
              <div className="col-6 col-md-4 col-lg-3" key={img.id}>
                <div className="brand-gallery-item" onClick={() => setLightboxImg(resolveImageSrc(img.src))}>
                  <img 
                    src={resolveImageSrc(img.src)} 
                    alt={img.label || 'Gallery Image'} 
                    className="img-fluid rounded" 
                    onError={handleImgError}
                  />
                </div>
              </div>
            ))}
            {!loading && filteredImages.length === 0 && (
              <p className="text-center text-muted">No images found for this category.</p>
            )}
          </div>
        )}

        {/* Lightbox */}
        {lightboxImg && (
          <div className="brand-lightbox open" onClick={() => setLightboxImg(null)}>
            <div className="brand-lightbox-wrapper">
              <div className="brand-lightbox-content">
                <img src={lightboxImg} className="img-fluid brand-lightbox-img" alt="Preview" />
              </div>
            </div>
            <div className="brand-lightbox-close" onClick={() => setLightboxImg(null)}>
              <span></span>
              <span></span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default FilterGallery;
